exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".shipping-time{font-weight:800}.model-img-cont{margin:0 auto}.model-img-cont img{max-width:90%}.p-button{background:#293642;border:1px solid #293642}.p-datatable .p-sortable-column.p-highlight{background:#969696;color:#fff}.model-name-cont b{color:#333}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-750dd84e","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/view/pages/Suppliers.vue
// module id = 374
// module chunks = 0